/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import AdminSideNavigation from 'bundles/admin-v2/components/AdminSideNavigation';
import type { Partner } from 'bundles/admin-v2/constants/types';

const styles = {
  adminHomeContainer: () => css`
    margin: var(--cds-spacing-400) var(--cds-spacing-400) 100px 325px;
    min-width: 720px;
  `,
};

type Props = {
  children: JSX.Element;
  selectedPartner: Partner;
  selectedPartnerId: number;
  partners: Partner[] | undefined;
};

const AdminHome: React.FC<Props> = ({ children, selectedPartner, selectedPartnerId, partners }) => {
  return (
    <div
      css={{
        height: '100%',
      }}
    >
      <AdminSideNavigation
        selectedPartner={selectedPartner}
        selectedPartnerId={selectedPartnerId}
        partners={partners}
      />
      <div css={styles.adminHomeContainer}>
        {children &&
          React.cloneElement(children, {
            selectedPartner,
            selectedPartnerId,
            partners,
          })}
      </div>
    </div>
  );
};

export default AdminHome;
